import { render } from "./TestSwiper.vue?vue&type=template&id=a9c7168a&scoped=true"
import script from "./TestSwiper.vue?vue&type=script&lang=js"
export * from "./TestSwiper.vue?vue&type=script&lang=js"

import "./TestSwiper.vue?vue&type=style&index=0&id=a9c7168a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9c7168a"]])

export default __exports__